module.exports = "pegasus/assets/graycircle-tumblr.png";